import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Stats } from '../../../model/stats/stats';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class StatsService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Get the 'Stats' json data
   * @returns an Observable
   */
  public getStatsData(): Observable<Stats> {
    return this.authGetObs<Stats>(APIUrls.getStatsUrl());
  }
}
